<template>
  <button
    class="my-button"
    :class="{
      'my-button--teal': type === 'teal',
      'my-button--fill-blue': type === 'fill-blue',
      'my-button--fill-red': type === 'fill-red',
      'my-button--outline-red': type === 'outline-red',
      'my-button--fill-yellow': type === 'fill-yellow',
      'my-button--block': block !== false
    }"
    @click="$emit('click')"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "normal"
    },
    block: {
      default: false
    }
  }
};
</script>

<style>
.my-button {
  height: 35.3px;
  border-radius: 5px;
  border: solid 1px #009feb;
  background-color: #ffffff;
  font-size: 11px;
  color: #009feb;
  padding: 0 26px;
  font-weight: bold;
}

.my-button:hover,
.my-button--fill-blue {
  background-color: #009feb;
  color: #fff;
}

.my-button--fill-blue:hover {
  background-color: #0292d4;
}

.my-button--fill-red {
  color: #fff;
  border-color: #ff216c;
  background-color: #ff216c;
}

.my-button--fill-red:hover {
  background-color: #e91159;
}

.my-button--outline-red {
  border: solid 1px #f874a9;
  color: #f874a9;
  background-color: #fff;
}

.my-button--outline-red:hover {
  color: #fff;
  background-color: #f874a9;
}

.my-button--fill-yellow {
  color: #fff;
  border-color: #ff7e1f;
  background-color: #ff7e1f;
}

.my-button--fill-yellow:hover {
  background-color: #e96b11;
}

.my-button--teal {
  background-color: #00cbae;
  color: #fff;
}

.my-button--teal:hover {
  background-color: #03bda1;
}

.my-button--block {
  width: 100%;
}
</style>
